// extracted by mini-css-extract-plugin
export default {"provider":"styles_provider__ygJH5","providerName":"styles_providerName__LhUXO","cutInfo":"styles_cutInfo__O2YRh","icon":"styles_icon__knFSQ"};